/**
 * Utility function to reduce the number of classes added to an element for font size
 *
 * We want to avoid situations where we send back font-group-bigger md:font-group-bigger lg:font-group-bigger
 * In these scenarios we just want to return font-group-bigger
 *
 * However, if we have font-group-bigger md:font-group-bigger lg:font-group-huge
 * then we want to return font-group-bigger lg:font-group-huge
 *
 * This helper is sent to the cva class utility, and if properties are omitted, the CSS class isn't returned
 *
 * @param obj
 * @param prop
 * @param suffix
 */
export const getFontSizeObject = (
  obj: Record<any, any>,
  prop: string,
  suffix: string = ''
) => {
  const defaultSize = obj[`${prop}`] ?? false;
  const smSize = obj[`${prop}Small${suffix}`] ?? false;
  const mdSize = obj[`${prop}Medium${suffix}`] ?? false;
  const lgSize = obj[`${prop}Large${suffix}`] ?? false;

  if (
    defaultSize ||
    (!mdSize && !lgSize) ||
    (smSize?.value === mdSize?.value && mdSize?.value === lgSize?.value) ||
    (smSize?.value === mdSize?.value && !lgSize)
  ) {
    return { sizeSm: defaultSize?.value ?? smSize?.value ?? 'normal' };
  }

  if (smSize?.value === mdSize?.value && lgSize) {
    return {
      sizeSm: smSize?.value ?? 'normal',
      sizeLg: lgSize?.value ?? 'normal',
    };
  }

  if (mdSize?.value === lgSize?.value) {
    return {
      sizeSm: smSize?.value ?? 'normal',
      sizeMd: mdSize?.value ?? 'normal',
    };
  }

  return {
    sizeSm: smSize?.value ?? 'normal',
    sizeMd: mdSize?.value ?? 'normal',
    sizeLg: lgSize?.value ?? 'normal',
  };
};
